(function () {
  'use strict';

  if (customElements.get('blog-search')) return;

  customElements.define(
    'blog-search',
    class BlogSearch extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.input = this.querySelector('.blog-search__input');
        this.panel = this.querySelector('[data-blog-search-panel]');
        this.status = this.querySelector('[data-blog-search-status]');
        this.clearBtn = this.querySelector('[data-blog-search-clear]');
        this.form = this.querySelector('form');
        this.blogHandle = this.getAttribute('data-blog-handle') || '';
        this.suggestUrl = this.getAttribute('data-suggest-url') || '/search/suggest.json';
        this.emptyTemplate = this.getAttribute('data-empty-template') || 'No articles match “__QUERY__”.';
        this.noneLabel = this.getAttribute('data-none-label') || 'No articles found';
        this.countOther = this.getAttribute('data-count-other') || '__COUNT__ articles found';
        this.results = [];
        this.activeIndex = -1;
        this.timer = null;
        this.controller = null;

        if (!this.input || !this.panel) return;

        this.form.addEventListener('submit', function (event) {
          event.preventDefault();
          var target = this.results[this.activeIndex] || this.results[0];
          if (target) {
            window.location.href = target.url;
            return;
          }
          this.search(this.input.value, true);
        }.bind(this));

        this.input.addEventListener('input', function () {
          this.toggleClear();
          this.queueSearch(this.input.value);
        }.bind(this));

        this.input.addEventListener('keydown', this.onKeyDown.bind(this));
        this.input.addEventListener('focus', function () {
          if (this.input.value.trim() && this.results.length) this.open();
        }.bind(this));

        if (this.clearBtn) {
          this.clearBtn.addEventListener('click', function () {
            this.input.value = '';
            this.results = [];
            this.activeIndex = -1;
            this.toggleClear();
            this.close();
            this.setStatus('');
            this.input.focus();
          }.bind(this));
        }

        document.addEventListener('click', function (event) {
          if (!this.contains(event.target)) this.close();
        }.bind(this));
      }

      toggleClear() {
        if (!this.clearBtn) return;
        this.clearBtn.hidden = !this.input.value;
      }

      queueSearch(value) {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(function () {
          this.search(value);
        }.bind(this), 180);
      }

      search(value, force) {
        var query = String(value || '').trim();
        if (query.length < 2) {
          this.results = [];
          this.close();
          this.setStatus('');
          return;
        }

        if (this.controller) this.controller.abort();
        this.controller = new AbortController();

        var params = new URLSearchParams({
          q: query,
          'resources[type]': 'article',
          'resources[limit]': '10',
          'resources[options][fields]': 'title,body,tag,author'
        });

        fetch(this.suggestUrl + '?' + params.toString(), {
          signal: this.controller.signal,
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            var articles = (((data || {}).resources || {}).results || {}).articles || [];
            this.results = articles.filter(function (article) {
              var url = String(article.url || '');
              return !this.blogHandle || url.indexOf('/blogs/' + this.blogHandle) !== -1;
            }.bind(this));
            this.render(query);
            if (force || this.results.length || query) this.open();
          }.bind(this))
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            this.results = [];
            this.render(query);
            this.open();
          }.bind(this));
      }

      render(query) {
        this.activeIndex = -1;

        if (!this.results.length) {
          this.panel.innerHTML =
            '<p class="blog-search__empty">' +
            this.escape(this.emptyTemplate.replace('__QUERY__', query)) +
            '</p>';
          this.setStatus(this.noneLabel);
          return;
        }

        this.panel.innerHTML = this.results
          .map(function (article, index) {
            var image = article.image || (article.featured_image && article.featured_image.url) || '';
            var excerpt = this.plain(article.body || article.excerpt || '');
            return (
              '<a class="blog-search__option" role="option" id="BlogSearchOption-' +
              index +
              '" href="' +
              this.escape(article.url) +
              '" aria-selected="false">' +
              (image
                ? '<img class="blog-search__thumb" src="' + this.escape(image) + '" alt="" width="56" height="56">'
                : '<span class="blog-search__thumb blog-search__thumb--empty"></span>') +
              '<span class="blog-search__copy">' +
              '<span class="blog-search__title">' +
              this.escape(article.title || '') +
              '</span>' +
              (excerpt ? '<span class="blog-search__excerpt">' + this.escape(excerpt) + '</span>' : '') +
              '</span></a>'
            );
          }.bind(this))
          .join('');

        this.setStatus(this.countOther.replace('99', String(this.results.length)).replace('__COUNT__', String(this.results.length)));
      }

      onKeyDown(event) {
        if (!this.results.length && event.key !== 'Escape') return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.move(1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.move(-1);
        } else if (event.key === 'Escape') {
          this.close();
          this.input.blur();
        }
      }

      move(step) {
        if (!this.results.length) return;
        this.open();
        this.activeIndex = (this.activeIndex + step + this.results.length) % this.results.length;
        var options = this.panel.querySelectorAll('.blog-search__option');
        options.forEach(function (option, index) {
          var selected = index === this.activeIndex;
          option.setAttribute('aria-selected', selected ? 'true' : 'false');
          if (selected) option.scrollIntoView({ block: 'nearest' });
        }.bind(this));
        this.input.setAttribute('aria-activedescendant', 'BlogSearchOption-' + this.activeIndex);
      }

      open() {
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message || '';
      }

      plain(value) {
        var text = String(value || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        return text.length > 90 ? text.slice(0, 87) + '…' : text;
      }

      escape(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }
    }
  );
})();
